module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('a', {
    attrs: {
      "id": "page_xxvi"
    }
  }), _vm._v(" "), _c('h2', {
    staticClass: "fmtitle"
  }, [_vm._v("Transliteration of Russian Names")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "dropcap"
  }, [_vm._v("T")]), _vm._v("he author and the editors followed the method of transliteration of Russian, Belarusian and Ukrainian names used by the Joint Technical Language Service (JTLS), part of the British GCHQ, which is based on British Standard. British Standard 2979 (1958) is the main system of the Oxford University Press – see Anne Waddingham, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("New Hart’s Rules: The Oxford Style Guide")]), _vm._v(" (OUP, 2014). In cases where a specific English version of names of well-known individuals and historical figures has become firmly established, we have in most cases retained that version, for example: Vasili (instead of Vasiliy or Vasily, see Vasili Mitrokhin), "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Izvestia")]), _vm._v(" (instead of "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Izvestiya")]), _vm._v("), or Beria (instead of Beriya). At the same time, we have used Lugovoy (instead of ‘Lugovoi’) and Iosif (instead of ‘Joseph’) Stalin.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0c1b3027","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/Transliteration.vue
// module id = 87
// module chunks = 0